export const content = {
  phone: 'Telefon:',
  mail: 'E-Mail:',
}
